import {Component, OnInit, TemplateRef} from '@angular/core';
// import {BsModalRef, BsModalService, TypeaheadMatch} from 'ngx-bootstrap';
import {MetadataStructure, MetadataStructureListResult} from '../../model/filter/stateListResult.model';
// tslint:disable-next-line:max-line-length
import {PanelConfigurationChartMetadata, PanelConfigurationChartMetadataItem } from '../../model/configuration/panelConfigurationChartMetadata.model';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {FilterService} from '../../services/filter/filter.service';
import {ConfigurationService} from '../../services/configuration/configuration.service';
import {ToastrService} from 'ngx-toastr';
import {BusinessProcessDimension, BusinessProcessDimensionListResult} from '../../model/configuration/businessProcessDimension.model';
import {forkJoin} from 'rxjs';
import {PanelConfigurationChartMetadataListResult} from '../../model/configuration/panelConfigurationChartMetadataResult';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';
import {GenericModalService} from '../../services/utils/generic-modal.service';

export interface SelectOption {
  id?: string;
  text?: string;
}

@Component({
  selector: 'app-approval-chart',
  templateUrl: './approval-chart.component.html',
  styleUrls: ['./approval-chart.component.css']
})
export class ApprovalChartComponent implements OnInit {

  businessProcessDimensionList: Array<BusinessProcessDimension> = [];
  metadataStructureList: Array<any> = [];

  selectedChartMetadata: PanelConfigurationChartMetadata;
  selectedChartMetadataItem: PanelConfigurationChartMetadataItem;

  panelConfigurationChartMetadataList: Array<PanelConfigurationChartMetadata>;

  isConfigLoading: boolean;

  domainValue: string;
  isSaving: boolean;
  isValidApprovalChartName: boolean;
  isValidateApprovalLegendLabel: boolean;
  isValidDomain: boolean;
  isValidMetadataName: boolean;
  successfullySaved: boolean;
  hasItem = false;
  textAction: string;

  successfullySavedChartMetadata: boolean;

  disabled = false;

  filteredStatesSelected: string;
  errorState: boolean;

  items: SelectOption[] = [];

  isEdit = false;

  constructor(private modalService: BsModalService, private filterService: FilterService,
              private configurationService: ConfigurationService, private fb: FormBuilder,
              private toastr: ToastrService, public bsModalRef: BsModalRef,
              public genericModalService: GenericModalService) {

    this.isConfigLoading = false;
    this.selectedChartMetadata = new PanelConfigurationChartMetadata;
    this.selectedChartMetadataItem = new PanelConfigurationChartMetadataItem();
    this.panelConfigurationChartMetadataList = new Array<PanelConfigurationChartMetadata>();
  }

  metadataStructureCtrl = new FormControl();
  formMetadataStructure = new FormGroup({
    metadataList: this.metadataStructureCtrl
  });

  errorBP: boolean;
  errorBPMessage: string;

  businessProcessDimension: BusinessProcessDimension;
  bPListSelected: string;

  // Reactive forms
  businessProcessCtrl = new FormControl();

  formBusinessProcess = new FormGroup({
    businessProcessList: this.businessProcessCtrl
  });


  typeaheadNoResults(noResults: boolean) {
    this.isValidMetadataName = !noResults;
    console.log(noResults);
  }

  ngOnInit() {
    this.getBusinessProcess();
    this.listPanelConfigurationIndicators();
  }

  configEditingModal() {
    this.getMetadataStructures();
    this.isValidDomain = true;
    this.isValidApprovalChartName = true;
    this.isValidateApprovalLegendLabel = true;
    this.isValidMetadataName = true;
    this.successfullySaved = false;
    this.domainValue = undefined;
    this.isSaving = false;
  }

  onClickNew(staticModel: TemplateRef<any>) {

    this.isEdit = false;
    this.textAction = 'Novo';
    this.configEditingModal();
    this.isValidApprovalChartName = false;
    this.isValidMetadataName = false;
    this.selectedChartMetadata = new PanelConfigurationChartMetadata();
    this.selectedChartMetadataItem = new PanelConfigurationChartMetadataItem();

    this.successfullySaved = false;
    this.successfullySavedChartMetadata = false;
    this.isSaving = false;

    this.bsModalRef = this.genericModalService.showObjModalWithTemplate(staticModel, {});
  }

  getMetadataStructures(): void {
    this.filterService.getMetadataStructures().subscribe((resp: MetadataStructureListResult) => {
      if (resp.result) {
        this.metadataStructureList = resp.result;
      } else if (resp.error) {
        this.toastr.error(resp.errorMessage, 'Erro', {positionClass: 'toast-top-center'});
      }
    });
  }

  public getBusinessProcess() {
    const getBusinessProcessCall = this.filterService.getBusinessProcess();

    forkJoin([getBusinessProcessCall]).subscribe(results => {
      const resultBPs: BusinessProcessDimensionListResult = results[0] as BusinessProcessDimensionListResult;
      if (resultBPs.result) {

        this.businessProcessDimensionList = resultBPs.result;
      }
    });
  }

  listPanelConfigurationIndicators(): void {

    this.configurationService.listPanelConfigurationChartMetadata().subscribe(async (resp: PanelConfigurationChartMetadataListResult) => {

      if (resp.result) {
        this.panelConfigurationChartMetadataList = resp.result;
      } else if (resp.error) {

        this.toastr.error(resp.errorMessage, 'Erro', { positionClass: 'toast-top-center' });
      }

    });
  }

  onClickAddApprovalChartConfigurationItem() {

    if (!this.isValidForm()) {
      this.toastr.error('Não é possível salvar pois existe(m) campo(s) inválido(s).', 'Erro', { positionClass: 'toast-top-center'});
      return;
    }

    if (this.selectedChartMetadataItem === undefined) {
      this.selectedChartMetadataItem = new PanelConfigurationChartMetadataItem();
    }

    this.validateApprovalLegendLabel();
    const existsSameLabel = this.selectedChartMetadata.items
        .filter(x => x.legendLabel === this.selectedChartMetadataItem.legendLabel).length > 0;

    if (existsSameLabel) {
      this.toastr.error('Já existe uma legenda com o mesmo nome', 'Erro', { positionClass: 'toast-top-center'});
      return;
    }
    this.validateDomain();

    this.selectedChartMetadata.items.push(this.selectedChartMetadataItem);
    this.selectedChartMetadata.items = [...this.selectedChartMetadata.items];

    this.selectedChartMetadataItem = new PanelConfigurationChartMetadataItem();
    this.removeBPListSelected();
  }

  onClickSaveApprovalChartConfiguration() {

    this.isSaving = true;
    this.configurationService.savePanelConfigurationChartMetadata(this.selectedChartMetadata)
      .subscribe(
        (resp: any) => {
          if (resp.result) {

            this.selectedChartMetadata.id = resp.result.id;
            this.successfullySaved = true;
            this.successfullySavedChartMetadata = true;
            this.toastr.success('Configuração salva com sucesso!', 'Sucesso', {positionClass: 'toast-top-center'});
            this.isSaving = false;

            this.listPanelConfigurationIndicators();
          } else if (resp.error) {
            this.successfullySaved = false;
            this.successfullySavedChartMetadata = false;
            this.isSaving = false;
            this.toastr.error(resp.errorMessage, 'Erro', {positionClass: 'toast-top-center'});
          }
          this.isSaving = false;
        }
      );
  }

  onClickSaveApprovalChartItemConfiguration() {

    this.isSaving = true;
    this.configurationService.savePanelConfigurationChartMetadata(this.selectedChartMetadata)
      .subscribe(
        (resp: any) => {
          if (resp.result) {
            this.successfullySaved = true;
            this.toastr.success('Itens agrupamento salvo com sucesso!', 'Sucesso', {positionClass: 'toast-top-center'});
            this.isSaving = false;
            this.onCloseModal();
            this.listPanelConfigurationIndicators();
          } else if (resp.error) {
            this.successfullySaved = false;
            this.isSaving = false;
            this.toastr.error(resp.errorMessage, 'Erro', {positionClass: 'toast-top-center'});
          }
          this.isSaving = false;
        }
      );
  }

  onClickEdit(content: PanelConfigurationChartMetadata , staticModel: TemplateRef<any>) {
    this.configEditingModal();

    this.textAction = 'Editar';
    this.selectedChartMetadata = content;

    this.isEdit = true;
    this.bsModalRef = this.genericModalService.showObjModalWithTemplate(staticModel, {});
    this.isValidForm();

  }

  onClickConfirmDelete(content: PanelConfigurationChartMetadata) {
    this.selectedChartMetadata = content;
  }

  onClickDeleteApprovalChartConfiguration() {

    this.configurationService.deletePanelConfigurationChartMetadata(this.selectedChartMetadata.id).subscribe((resp: any) => {
      this.toastr.success('Configuração ' + this.selectedChartMetadata.name +
        ' excluída com sucesso!', 'Sucesso');
      this.listPanelConfigurationIndicators();
    });
  }

  onClickDeleteItem(content: PanelConfigurationChartMetadataItem) {

    const index: number = this.selectedChartMetadata.items.findIndex(x => x.id === content.id);

    if (index > -1) {
      this.selectedChartMetadata.items.splice(index, 1);
    }

    if (this.selectedChartMetadata.items.length === 0) {
      this.hasItem = false;
    }

    this.validateDomain();

  }


  onChangeApprovalChartName() {
    this.validateApprovalChartName();
  }

  validateApprovalChartName() {
    return this.isValidApprovalChartName = this.selectedChartMetadata.name !== undefined &&
      this.selectedChartMetadata.name.trim() !== '';
  }

  onChangeApprovalLegendLabel() {
    this.validateApprovalLegendLabel();
  }

  validateApprovalLegendLabel() {
    return this.isValidateApprovalLegendLabel = this.selectedChartMetadataItem.legendLabel !== undefined &&
      this.selectedChartMetadataItem.legendLabel.trim() !== '';
  }

  onSelectMetadata(event: TypeaheadMatch) {
     this.selectedChartMetadata.metadataStructure = event.item;
  }

  onCleanMetadataStructure() {
     this.selectedChartMetadata.metadataStructure = new MetadataStructure();
  }

  addDomainButtonIsDisabled() {
    return this.domainValue === undefined || this.domainValue.trim() === '';
  }

  onClickAddNewDomainValue(textContent: string) {

    if (this.selectedChartMetadataItem.domain === undefined) {
      this.selectedChartMetadataItem.domain = [];
    }
    if (this.selectedChartMetadataItem.domain.indexOf(textContent) > -1) {
      return;
    }
    this.selectedChartMetadataItem.domain.push(textContent);
    this.hasItem = true;
    this.domainValue = undefined;
    this.validateDomain();
  }

  validateDomain() {
    if (this.selectedChartMetadataItem.domain === undefined) {
      return this.isValidDomain = false;
    }
    return this.isValidDomain = this.selectedChartMetadataItem.domain.length > 0;
  }

  validateMetadataName() {
    return this.isValidMetadataName = this.selectedChartMetadata.metadataStructure !== undefined;
  }

  onClickDeleteDomainValue(content: string) {
    const index: number = this.selectedChartMetadataItem.domain.indexOf(content, 0);
    if (index > -1) {
      this.selectedChartMetadataItem.domain.splice(index, 1);
    }

    if (this.selectedChartMetadataItem.domain.length === 0) {
      this.hasItem = false;
    }

    this.validateDomain();
  }

  onSelectBP(event: TypeaheadMatch): void {

    this.businessProcessDimension = event.item;
    this.selectedChartMetadataItem.businessProcessDimension = this.businessProcessDimension;

    if (!this.bPListSelected || this.errorBP) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
  }

  typeaheadNoResultsBP(event: boolean): void {
    this.errorBP = event;
    this.errorBPMessage = 'Nenhum resultado encontrado';

    this.removeStateListSelected();
  }

  removeBPListSelected() {
    this.bPListSelected = '';
    this.errorBP = false;

    this.removeStateListSelected();
  }

  removeStateListSelected() {
    this.filteredStatesSelected = '';
    this.errorState = false;
  }

  onChangeBusinessProcess(): void {

    if (this.businessProcessDimension !== undefined) {
      this.filterService.getStates(this.businessProcessDimension.businessProcessId).subscribe((resp: any) => {
        if (resp.result) {

          this.itemsLoad(resp.result);
        }
      });
    }
  }

  itemsLoad(result: any) {

    this.items = [];

    result.forEach(item => {

      this.items.push({ id: (item.id.toString()), text: (item.name) });
    });
  }

  onCloseModal() {
    this.bsModalRef.hide();
  }

  private isValidForm() {
    this.validateApprovalChartName();
    this.validateApprovalLegendLabel();
    this.validateDomain();

    return this.isValidDomain && this.isValidApprovalChartName && this.isValidateApprovalLegendLabel;
  }

  onButtonSaveValidation() {
    if (this.isEdit) {
      // edição
      return !this.isValidateApprovalLegendLabel || this.errorBP || !this.isValidDomain;
    } else {
      // novo
      return !this.isValidApprovalChartName || !this.isValidMetadataName;
    }
  }
}
